import React, { useState, useEffect } from 'react';
import './SearchInput.css';

function SearchInput({ onSearch, disabled }) {
  const [query, setQuery] = useState('');
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  const placeholders = [
    "Explore Qur'an topics...",
    "Ask about Tawheed...",
    "Search Tafseer Ibn Kathir...",
    "What is the meaning of Surah Al-Fatiha?",
    "Learn about prophets in the Qur'an...",
    "Understanding Ayatul Kursi..."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    }, 3000); // Change placeholder every 3 seconds

    return () => clearInterval(interval);
  }, [placeholders.length]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim() && !disabled) {
      onSearch(query);
      setQuery('');
    }
  };

  return (
    <form className="search-input-container" onSubmit={handleSubmit}>
      <input
        type="text"
        className="search-input"
        placeholder={placeholders[placeholderIndex]}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        disabled={disabled}
      />
      <button
        type="submit"
        className="search-button"
        disabled={disabled || !query.trim()}
        aria-label="Search"
      >
        <img src="/icons/search.svg" alt="Search" className="search-icon" />
      </button>
    </form>
  );
}

export default SearchInput;
